import axios from '@/utils/axios'


export function getApiRepublicStatistic(params) {
	return axios({
		url: 'api/v1/republic-statistic',
		method: "GET",
		params
	})
}

export function getApiLaborResources(params) {
	return axios({
		url: 'api/v1/v1/labor-resources',
		method: "GET",
		params
	})
}

export function getApiEmployment(params) {
	return axios({
		url: 'api/v1/v1/employment',
		method: "GET",
		params
	})
}

export function getApiProfessionalTraining(params) {
	return axios({
		url: 'api/v1/professional-training',
		method: "GET",
		params
	})
}

export function getApiPublicWorks(params) {
	return axios({
		url: 'api/v1/public-works',
		method: 'GET',
		params
	})
}

export function getApiRecognitionUnemployed(params) {
	return axios({
		url: 'api/v1/unemployment',
		method: 'GET',
		params
	})
}

export function getApiSubsidy(params) {
	return axios({
		url: 'api/v1/subsidy',
		method: 'GET',
		params
	})
}

export function getApiJobs(params) {
	return axios({
		url: 'api/v1/jobs',
		method: 'GET',
		params
	})
}

export function getApiMigration(params) {
	return axios({
		url: 'api/v1/migration',
		method: 'GET',
		params
	})
}

export function getApiStateInspection(params) {
	return axios({
		url: 'api/v1/v1/dmi',
		method: 'GET',
		params
	})
}

export function getApiLaborSystem(params) {
	return axios({
		url: 'api/v1/v1/yammt',
		method: 'GET',
		params
	})
}

// * Indicator APIs
export function getApiMainIndicator(params) {
	return axios({
		url: 'api/v1/indecator/main-indicator',
		method: 'GET',
		params
	})
}

export function getApiEmployedServiced(params) {
	return axios({
		url: 'api/v1/indecator/employed-on-serviced',
		method: 'GET',
		params
	})
}

export function getApiJobSearchDirections(params) {
	return axios({
		url: 'api/v1/indecator/job-search-directions',
		method: 'GET',
		params
	})
}

export function getApiYAMMT(params) {
	return axios({
		url: 'api/v1/yammt',
		method: 'GET',
		params
	})
}